import { render, staticRenderFns } from "./ImpersonateDialog.vue?vue&type=template&id=cfbba14c&"
import script from "./ImpersonateDialog.vue?vue&type=script&lang=js&"
export * from "./ImpersonateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports